import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-course-analytics',
  templateUrl: './course-analytics.component.html',
  styleUrl: './course-analytics.component.scss',
})
export class CourseAnalyticsComponent implements OnInit {
  iframeUrl = '';

  constructor() {}

  ngOnInit(): void {
    this.iframeUrl = `https://embed.figma.com/proto/79LoXJiZuZU6aCcCz3iFwF/Analyse_Kurse?node-id=1-8&p=f&scaling=scale-down-width&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A8&embed-host=share&hide-ui=1`;
  }
}
